"use strict";
// import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
// import styles from './CatalogBrand.module.scss';
// import { CarBrand } from '../../interfaces/catologCars.interface';
// import { Loader } from '../loader/Loader';
// import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
// import { CarCatologIcons } from '../CarCatologIcons/CarCatologIcons';
// import { ArrowDownOutlined, ArrowUpOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
// import { Grid, Mousewheel, Pagination } from 'swiper/modules';
// import { mediaQuerySelector } from '../../redux/selectors';
// import { useSelector } from 'react-redux';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InStock = void 0;
// export var InStock = (): React.JSX.Element => {
//     var [carsCatalog, setCarsCatalog] = useState<CarBrand[] | null>(null);
//     var [isLoadingCatalog, setLoadingCatalog] = useState<boolean>(false);
//     var [isDesktop, setIsDesktop] = useState(false);
//     var swiperCardRef = useRef<null | SwiperRef>(null);
//     var [visibleMore, setVisibleMore] = React.useState(false);
//     var isSmall = useSelector(mediaQuerySelector).isSmall;
//     var visibleItems = useMemo(() => {
//         return visibleMore ? carsCatalog : carsCatalog?.slice(0, isSmall ? 18 : 24);
//     }, [isSmall, carsCatalog, visibleMore]);
//     var handleMoreBtn = () => {
//         setVisibleMore((prev) => !prev);
//     };
//     useEffect(() => {
//         var fetchData = async () => {
//             setLoadingCatalog(true);
//             try {
//                 var response = await fetch(`${process.env.REACT_APP_BASE_URL!}/car_catalogs/all_catalog`);
//                 var result = await response.json();
//                 setCarsCatalog(result);
//                 setLoadingCatalog(false);
//             } catch (err) {
//                 console.log(err);
//             }
//         };
//         fetchData();
//     }, []);
//     useEffect(() => {
//         var handleResize = () => {
//             setIsDesktop(window.innerWidth > 1160);
//         };
//         handleResize();
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);
//     var handleNext = useCallback((): void => {
//         swiperCardRef.current?.swiper.slideNext();
//     }, []);
//     var handlePrev = useCallback((): void => {
//         swiperCardRef.current?.swiper.slidePrev();
//     }, []);
//     return (
//         <div className={styles.container}>
//             <div className={styles.page}>
//                 {/* <div className={styles.in_stock__inner}>
//                     <h2 className={styles.in_stock__title}>Автомобили в наличии</h2>
//                 </div> */}
//                 <div className={styles.catalog}>
//                     {isLoadingCatalog ? (
//                         <Loader />
//                     ) : (
//                         <>
//                             {isDesktop ? (
//                                 <div>
//                                     <div className={styles.top__brands_container}>
//                                         {visibleItems?.map((car) => {
//                                             return (
//                                                 <CarCatologIcons key={`${car.brand}_${car.models_count}`} {...car} />
//                                             );
//                                         })}
//                                     </div>
//                                     <button className={styles.in_stock__btn_more} onClick={handleMoreBtn} type="button">
//                                         Показать больше марок{' '}
//                                         {visibleMore ? (
//                                             <ArrowUpOutlined className={styles.in_stock__arrow_icon} />
//                                         ) : (
//                                             <ArrowDownOutlined className={styles.in_stock__arrow_icon} />
//                                         )}
//                                     </button>
//                                 </div>
//                             ) : (
//                                 <>
//                                     <Swiper
//                                         ref={swiperCardRef}
//                                         touchEventsTarget="container"
//                                         breakpoints={{
//                                             300: {
//                                                 slidesPerView: 2,
//                                                 grid: {
//                                                     rows: 3,
//                                                 },
//                                                 spaceBetween: 5,
//                                             },
//                                             512: {
//                                                 slidesPerView: 3,
//                                                 grid: {
//                                                     rows: 3,
//                                                 },
//                                                 spaceBetween: 10,
//                                             },
//                                             750: {
//                                                 slidesPerView: 4,
//                                                 grid: {
//                                                     rows: 3,
//                                                 },
//                                                 spaceBetween: 10,
//                                             },
//                                             930: {
//                                                 slidesPerView: 5,
//                                                 grid: {
//                                                     rows: 3,
//                                                 },
//                                                 spaceBetween: 10,
//                                             },
//                                             1160: {
//                                                 slidesPerView: 6,
//                                                 grid: {
//                                                     rows: 3,
//                                                 },
//                                                 spaceBetween: 10,
//                                             },
//                                         }}
//                                         mousewheel={true}
//                                         pagination={{
//                                             dynamicBullets: true,
//                                             clickable: true,
//                                         }}
//                                         modules={[Pagination, Grid, Mousewheel]}
//                                         className={styles.top__brands_container}
//                                         wrapperClass={styles.swiper__wrapper}
//                                     >
//                                         {carsCatalog?.map((car) => {
//                                             return (
//                                                 <SwiperSlide key={`${car.brand}_${car.models_count}`}>
//                                                     <CarCatologIcons {...car} />
//                                                 </SwiperSlide>
//                                             );
//                                         })}
//                                         <div className={styles.box_vector}>
//                                             <button className={styles.box_vector__vector_left} onClick={handlePrev}>
//                                                 <LeftOutlined />
//                                             </button>
//                                             <button className={styles.box_vector__vector_right} onClick={handleNext}>
//                                                 <RightOutlined />
//                                             </button>
//                                         </div>
//                                     </Swiper>
//                                 </>
//                             )}
//                         </>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };
// Закоментировать все выше полностью, и раскоментировать все ниже при деплое на usecar
var react_1 = __importDefault(require("react"));
var InStock_module_scss_1 = __importDefault(require("./InStock.module.scss"));
var InStockList_1 = require("../inStockList/InStockList");
var Skeleton_1 = require("../skeleton/Skeleton");
var InStock = function () {
    return (react_1.default.createElement("section", { className: InStock_module_scss_1.default.in_stock },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: InStock_module_scss_1.default.in_stock__inner },
                react_1.default.createElement("h2", { className: InStock_module_scss_1.default.in_stock__title }, "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438"),
                react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement(Skeleton_1.Skeleton, { height: 150, count: 5 }) },
                    react_1.default.createElement(InStockList_1.InStockList, null))))));
};
exports.InStock = InStock;
exports.default = exports.InStock;
